define('views/modules/profile/edit/create-options-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/api',
    'services/i18n',
    'services/events/user-events',
    'services/user',
    // views
    'views/parts/info-section',
    'views/parts/form/choices',
    'views/parts/form/textarea-advanced',
    'views/parts/form/datepicker',
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-dropdown',
    'views/parts/form/multiple-selector',
    'views/parts/view-toggle',
    // models
    'models/conversation/conversation',
    'models/questionnaire/questionnaire',
    'models/template/template',
    // collections
    'collections/conversation/custom-messages',
    // templates
    'text!templates/modules/profile/edit/create-options-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    API,
    i18n,
    UserEvents,
    User,
    // views
    VInfoSection,
    VChoices,
    VTextareaAdvanced,
    VDatePicker,
    VTreeView,
    VMenuDropdown,
    VMultipleSelector,
    VViewToggle,
    // models
    MConversation,
    MQuestionnaire,
    MTemplate,
    // collections
    CCustomMessages,
    // templates
    TCreateOptionsEditForm
) {

    var VCreateOptionsEditForm = Backbone.View.extend({
        template: TCreateOptionsEditForm,

        regions: {
            form: {
                expiration: '.expiration-input',
                sendInvite: '.send-invite-input',
                welcomeMessage: '.welcome-message-input',
                groups: "#group-menu",
                addQuestionnairesToggle: ".add-questionnaires-toggle",
                addQuestionnaires: ".add-questionnaires",
                addTemplatesToggle: ".add-templates-toggle",
                addTemplates: ".add-templates",
            }
        },


        initialize: function(opt) {
            this.selectedGroup = opt.selectedGroup;
            this.options = opt || {};

            var conversation = this.model.conversation = new MConversation();
            this.customMessages = new CCustomMessages();

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.collection
            });

            this.view = {
                info: new VInfoSection({
                    title: "supervisor:member-additionnal-settings",
                    content: this.template,
                }),
                form: {
                    groups: new VMenuDropdown({
                        displayManageGroup: User.getMainGroup().isOwner,
                        label: "Group",
                        context: this,
                        showLabel: true,
                        labelposition: "top",
                        callback: this.onDisplayGroupManager,
                        collection: new Backbone.Collection([
                            { tree: true, tree_only: true, view: groupTreeView }
                        ]),
                    }),
                    sendInvite: new VChoices({
                      label: "form-profile-send-invitation-caption",
                      attribute: "_sendInvite",
                      help: 'form-profile-send-invitation-help',
                      model: this.model
                    }),
                    welcomeMessage: new VTextareaAdvanced({
                        label: i18n.t('Welcome Message'),
                        attribute: 'message',
                        height: "120px",
                        labelposition: 'outer',
                        help: 'form-profile-welcome-message-help',
                        model: conversation,
                        toolbar: [
                            ['style', ['bold', 'italic', 'underline']],
                            ['insert', ['link']],
                            ['customButtons', ['messagesTemplate']]
                        ]
                    }),
                    expiration: new VDatePicker({
                        label: 'Expiration',
                        attribute: '_expire',
                        model: this.model,
                        help: 'form-profile-expiration-help',
                        labelposition: "outer",
                        format: API.format.timestamp,
                    }),
                    addQuestionnaires: new VMultipleSelector({
                        collection: this.options.questionnaires,
                        selectOptions: { label: 'title', value: 'id' },
                        noneSelectedText: i18n.t('select-questionnaires'),
                        emptyCollectionError: 'you-have-no-questionnaires',
                        helpText: 'add-questionnaires-help',
                    }),
                    addTemplates: new VMultipleSelector({
                        collection: this.options.templates,
                        selectOptions: { label: 'name', value: '_id' },
                        noneSelectedText: i18n.t('select-templates'),
                        emptyCollectionError: 'you-have-no-templates',
                        helpText: 'add-templates-help',
                    }),
                }
            };

            this.view.form.addQuestionnairesToggle = new VViewToggle({
                view: this.view.form.addQuestionnaires,
                label: "add-questionnaires-to-user",
                help: 'add-questionnaire-checkbox-help',
            });

            this.view.form.addTemplatesToggle = new VViewToggle({
                view: this.view.form.addTemplates,
                label: "add-templates-to-user",
                help: 'add-templates-checkbox-help',
            });

            // groups collection
            this.listenTo(this.collection, {
                'update': this.onGroupCollectionUpdate,
                'click': this.onGroupClick
            });

            this.listenTo(groupTreeView, 'click', this.onSelectGroup);
            this.listenTo(this.customMessages, 'sync', this.onCustomMessagesSync);
            this.listenTo(this.view.form.addTemplates, 'selectedItems:changed', this.onSelectedItemsChange);
            this.listenTo(this.view.form.addQuestionnaires, 'selectedItems:changed', this.onSelectedItemsChange);
        },
        render: function() {
            // append the form
            this.model.set('questionnaires', []);
            this.assign(this.view.info, this.$el);

            this.customMessages.fetch();

            this.generateZones();
            var view = this.view,
                zone = this.zone,
                conversation = this.model.conversation;

            conversation.setUser(this.model.id);
            var attributes = {
                    message: this.options.defaultWelcomeMsg,
                };
            conversation.attributes = _.extend(attributes, conversation.attributes);

            this.assign(view.form.sendInvite, zone.form.$sendInvite)
                .assign(view.form.welcomeMessage, zone.form.$welcomeMessage)
                .assign(view.form.expiration, zone.form.$expiration)
                .assign(view.form.addQuestionnaires, zone.form.$addQuestionnaires)
                .assign(view.form.addQuestionnairesToggle, zone.form.$addQuestionnairesToggle)
                .assign(view.form.addTemplates, zone.form.$addTemplates)
                .assign(view.form.addTemplatesToggle, zone.form.$addTemplatesToggle)
                .assign(view.form.groups, zone.form.$groups);

            view.form.expiration.clearDate();

            return this;
        },

        ////////////
        // events //
        ////////////
        onDisplayGroupManager: function() {
            UserEvents.groupManage();
        },

        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.at(0));
            }
            else {
              this.onSelectGroup(this.selectedGroup);
            }
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
            }

            this.view.form.groups.setLabel(selectedGroup.get('name'));
            this.model.setGroup(groupModel);
            this.view.form.groups.close();
            selectedGroup.set('_menuActive', true);
        },

        onSelectedItemsChange: function() {
            this.model.set('questionnaires', this.view.form.addQuestionnaires.getSelectedItems());
            this.model.set('templates', this.view.form.addTemplates.getSelectedItems());
        },

        onCustomMessagesSync: function() {
            var result = this.customMessages.findWhere({ defaultWelcomeMessage: true });

            if (result) {
                this.view.form.welcomeMessage.setValue(result.get('message'));
            }
        }

    });

    return VCreateOptionsEditForm;
});

